'use client';

import { c as _c } from "react/compiler-runtime";
import { Alert, AlertBody, Heading, LayoutLinelengthContainer, TextPassage } from '@petsmart-ui/sparky';
import type { ErrorMessageType } from './error.types';
type ErrorMessageProps = Readonly<{
  errorType: ErrorMessageType;
}>;
const errorMessages = {
  estimationValidation: {
    title: 'Not available in your area',
    description: 'Please select another fulfillment method'
  },
  emptyFields: {
    title: 'Information missing',
    description: 'Please review errors for missing information'
  },
  invalidFields: {
    title: 'Invalid entry',
    description: 'Please review the errors below'
  },
  apiError: {
    title: 'Something went wrong',
    description: "We couldn't verify your address. Please try again"
  }
};
export const ErrorMessage = t0 => {
  const $ = _c(7);
  const {
    errorType
  } = t0;
  const {
    title,
    description
  } = errorMessages[errorType];
  let t1;
  if ($[0] !== title) {
    t1 = <LayoutLinelengthContainer><Heading size="body-bold" tagName="h2">{title}</Heading></LayoutLinelengthContainer>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <TextPassage>{description}</TextPassage>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Alert variant="error" iconName="exclamation-circle-fill"><AlertBody>{t1}{t2}</AlertBody></Alert>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};